<template>
  <div class="form-card bg-white/80 backdrop-blur-xl rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-xl sm:shadow-2xl border border-gray-200/50 animate-fade-in-up">
    <div v-if="showHeader" class="text-center mb-4 sm:mb-6">
      <div 
        v-if="icon" 
        class="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full mb-3 sm:mb-4 shadow-lg sm:shadow-xl"
        :class="iconBgClass"
      >
        <slot name="icon" />
      </div>
      <h2 v-if="title" class="text-xl sm:text-2xl md:text-3xl font-bold mb-1 sm:mb-2 text-gray-900">{{ title }}</h2>
      <p v-if="subtitle" class="text-gray-600 text-sm sm:text-base">{{ subtitle }}</p>
    </div>
    
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FormCard',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    icon: { type: Boolean, default: false },
    iconBgClass: { type: String, default: 'bg-gradient-to-br from-blue-500 to-indigo-600' }
  },
  computed: {
    showHeader() {
      return this.title || this.subtitle || this.icon;
    }
  }
}
</script>
